import React, { useEffect } from 'react';
import "./Article.scss";
import { Link } from 'react-router-dom';
import { Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

const Article = ({ title, tag, img, author, description, height, width, fontSize, display, path }) => {

    const data = { tag, title, description, img }

    const handleClick = () => {
        scroll.scrollToTop();
    }

    return (
        <Link exact className="article" style={{ display: `${display}` }} to={{
            pathname: `/${title.toLowerCase().split(" ").join("-")}`, state: { data }
        }} onClick={handleClick}>
            <div style={{ height: `${height}`, minWidth: `${width}` }} className="article__container-img">
                <img className="article__img" src={img} alt={title} />
            </div>
            <div className="article__container-data">
                <h4 className="article__tag">{tag}</h4>
                <h3 style={{ fontSize: `${fontSize}` }} className="article__title">{title}</h3>
                <p className="article__description">{description}</p>
            </div>
        </Link>
    )
}

export default Article;
